module.exports = __webpack_public_path__ + "img/antes_despues_304.8d5ca4d7.png";